module.exports = __webpack_public_path__ + "static/media/featured_img_one.69a639f4.jpg";